"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LAST_UPDATED_TIMESTAMP_SYMBOL = void 0;
exports.LAST_UPDATED_TIMESTAMP_SYMBOL = "__lastUpdatedTimestamp";
//# sourceMappingURL=hard-limits.js.map